module.exports = __webpack_public_path__ + "media/images/social-app/social-image-82620f9b230991abf1d6fd29ee8aabd9.png";